var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "@wordpress/element";
import { __, sprintf } from "@wordpress/i18n";
import { ButtonType, WPQTButton, } from "../../../../components/common/Button/Button";
import { WPQTField } from "../../../../components/common/Form/Field";
import { WPQTFieldSet } from "../../../../components/common/Form/FieldSet";
import { WPQTLabel } from "../../../../components/common/Form/Label";
import { InputType, WPQTInput, } from "../../../../components/common/Input/Input";
import { Loading } from "../../../../components/Loading/Loading";
import { setUpUserPageRequest } from "../../../api/user-page-api";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { UserPageAppContext } from "../../../providers/UserPageAppContextProvider";
import { PageScreenMiddle, PageTitle } from "../Page/Page";
function SetUpPage() {
    const { state: { pageHash, userName }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [validationError, setValidationError] = useState("");
    useEffect(() => {
        if (password !== passwordRepeat) {
            setValidationError(__("Passwords do not match", "quicktasker"));
        }
        else {
            setValidationError("");
        }
    }, [password, passwordRepeat]);
    const submitSetup = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        if (!password || !passwordRepeat) {
            setValidationError(__("Please enter a password", "quicktasker"));
            return;
        }
        if (validationError) {
            return;
        }
        const data = { password };
        try {
            setLoading(true);
            yield setUpUserPageRequest(pageHash, data);
            window.location.reload();
        }
        catch (error) {
            handleError(error);
            setLoading(false);
        }
    });
    return (_jsxs(PageScreenMiddle, { children: [_jsx(PageTitle, { titleClassName: "wpqt-font-normal", description: __("Please complete the setup", "quicktasker"), children: sprintf(__("Hello %s", "quicktasker"), userName) }), _jsx("form", { onSubmit: submitSetup, children: _jsxs(WPQTFieldSet, { children: [_jsxs(WPQTField, { children: [_jsx(WPQTLabel, { className: "wpqt-text-center", children: __("Enter your new password", "quicktasker") }), _jsx(WPQTInput, { value: password, onChange: setPassword, type: InputType.PASSWORD })] }), _jsxs(WPQTField, { children: [_jsx(WPQTLabel, { className: "wpqt-text-center", children: __("Repeat your new password", "quicktasker") }), _jsx(WPQTInput, { value: passwordRepeat, onChange: setPasswordRepeat, type: InputType.PASSWORD })] }), validationError && (_jsx("div", { className: "wpqt-text-qtTextRed wpqt-mb-3", children: validationError })), _jsx(WPQTField, { className: "wpqt-text-center", children: loading ? (_jsx(Loading, { ovalSize: "32" })) : (_jsx(WPQTButton, { btnText: __("Setup", "quicktasker"), type: ButtonType.SUBMIT })) })] }) })] }));
}
export { SetUpPage };
